{
  "version": 1,
  "asset_id": "d59fc465-6a75-411d-aaee-72d5f12b9640",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/d59fc465-6a75-411d-aaee-72d5f12b9640/egg-damp.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/d59fc465-6a75-411d-aaee-72d5f12b9640/egg-damp.webp",
  "original_filename": "egg-damp.webp",
  "size": 6180,
  "content_type": "image/webp",
  "created_at": "2026-08-06T21:53:55Z"
}
